/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientDetailsSubmissionRequest } from './';
import {
    ClientDetailsSubmissionRequestFromJSON,
    ClientDetailsSubmissionRequestFromJSONTyped,
    ClientDetailsSubmissionRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateReferralSubmissionRequest
 */
export interface CreateReferralSubmissionRequest {
    /**
     * 
     * @type {ClientDetailsSubmissionRequest}
     * @memberof CreateReferralSubmissionRequest
     */
    clientDetails: ClientDetailsSubmissionRequest;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralSubmissionRequest
     */
    briefDescription: string;
}

/**
 * Check if a given object implements the CreateReferralSubmissionRequest interface.
 */
export function instanceOfCreateReferralSubmissionRequest(value: object): value is CreateReferralSubmissionRequest {
    if (!('clientDetails' in value) || value['clientDetails'] === undefined) return false;
    if (!('briefDescription' in value) || value['briefDescription'] === undefined) return false;
    return true;
}

export function CreateReferralSubmissionRequestFromJSON(json: any): CreateReferralSubmissionRequest {
    return CreateReferralSubmissionRequestFromJSONTyped(json, false);
}

export function CreateReferralSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientDetails': ClientDetailsSubmissionRequestFromJSON(json['clientDetails']),
        'briefDescription': json['briefDescription'],
    };
}

export function CreateReferralSubmissionRequestToJSON(value?: CreateReferralSubmissionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientDetails': ClientDetailsSubmissionRequestToJSON(value['clientDetails']),
        'briefDescription': value['briefDescription'],
    };
}

